/**
 * Created by yangxx on 2016/12/12.
 * 组件的基类
 * @module ComponentBase
 */
'use strict';
define([
    './Class',
    '../utils/CommonUtil',
    '../misc/AppEvent'
], function(
    Class,
    CommonUtil,
    AppEvent
) {
    /**
     * 组件构造
     * @constructor
     * @classdesc 组件基类
     * @alias G.base.ComponentBase
     * @augments G.base.Class
     * @param {Object} options - 必填，构造参数
     * @param {String} options.id - 必填，唯一标识
     * @param {String} options.name - 必填，名称
     * @param {G.Map} options.map - 必填，地图对象
     * @returns {Object} 实例化对象
     */
    var component = Class.extend({
        //默认配置项
        options: {
            /**
             * 组件对象的id
             */
            id: null,
            /**
             * 组件对象名称
             */
            name: null,
            /**
             * 地图对象
             */
            map: null
        },
        includes: AppEvent.prototype,
        initialize: function(options) {
            Class.setOptions(this, options);
            //移动this.options中的属性到this下
            this._moveAttrFromOpts(['map', 'id', 'name']);
            //
            //全局事件委托
            this.appEvent = null;
            if (this.map && this.map instanceof G.Map) {
                this.appEvent = this.map.getAppEvent();
            }
            //identifier
            this.id = this.id || CommonUtil.newUUID32();
            //
            this.loaded = false;
        },
        /**
         * 组件销毁
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        destroy: function() {
            this.unload();
            for (var key in this) {
                this[key] = null;
                delete this[key];
            }
        },
        /**
         * 加载，加载后组件处于激活状态（图层叠加、添加事件监听等）
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        load() {
            if (!this.loaded) {
                this.addListeners();
                this.loaded = true;
                this.fire('load');
            }
        },
        /**
         * 卸载，卸载后组件处于非激活状态（图层移除、取消事件监听等）
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        unload() {
            if (this.loaded) {
                this.removeListeners();
                this.loaded = false;
                this.fire('unload');
            }
        },
        /**
         * 是否处于加载状态
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        isLoaded() {
            return this.loaded;
        },

        /**
         * 检查是否加载
         * @returns {boolean}
         * @private
         */
        _checkLoaded() {
            if (this.isLoaded()) {
                return true;
            } else {
                throw (new Error('component id = ' + this.id + ' not loaded yet !'))
            }
        },

        /**
         * 添加事件监听
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        addListeners() {},
        /**
         * 移除事件监听
         * @method
         * @memberOf G.base.ComponentBase.prototype
         */
        removeListeners() {}
    });
    /***
     * 提供子类公用的方法
     */
    component.include({
        /**
         * 移动this.options下的属性到this下
         * @private
         * @param keyArr 属性key值的数组
         * @param keepOrigin 保留options下的属性
         */
        _moveAttrFromOpts: function(keyArr, keepOrigin) {
            var keyArr = keyArr || [];
            if (keyArr.constructor == Array) {
                for (var i = 0, len = keyArr.length; i < len; i++) {
                    var key = keyArr[i];
                    if (key) {
                        this[key] = this.options[key];
                        if (!keepOrigin) {
                            this.options[key] = null;
                            delete this.options[key];
                        }
                    }
                }
            }
        },
        /**
         * 判断非空非undefined
         * @private
         * @param obj {Object} - 必填
         * @returns {Boolean} - 为空返回true，否则返回ture；
         */
        isNotNull: function(obj) {
            return obj != null && (typeof obj != undefined);
        }
    });
    return component;
})